"use strict";
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericValue = void 0;
const react_1 = __importDefault(require("react"));
const formatting_1 = require("./formatting");
const NumericValue = ({ value, title, name, dp }) => {
    var _a;
    return (react_1.default.createElement("output", { name: name, title: (_a = title === null || title === void 0 ? void 0 : title.toString()) !== null && _a !== void 0 ? _a : value.toString(), style: { fontWeight: "bold", fontVariantNumeric: "tabular-nums" } }, typeof value === "number" ? (0, formatting_1.tidyNumber)(value, dp) : value));
};
exports.NumericValue = NumericValue;
//# sourceMappingURL=NumericValue.js.map